/* ================================================================
   BRAWN Interactions v1.0
   6 sistemas: Loading Screen · Custom Cursor · Pixel Trail ·
   Scroll Reveals · Watermark Parallax · Marquee
   Vanilla JS puro. Touch-aware. Zero deps.
   ================================================================ */

(function () {
  'use strict';


  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initHeader();
    initLoadingScreen();
    initScrollReveals();
    initMarquees();
    initParallax();
    initCardCart();
    initHeroCrossfade();
  }

  /* ─── 1. LOADING SCREEN ─────────────────────────────────────── */
  function initLoadingScreen() {
    var overlay = document.getElementById('brawn-loader');
    if (!overlay) return;

    if (sessionStorage.getItem('brawn-loaded')) {
      overlay.style.display = 'none';
      return;
    }

    var letters = overlay.querySelectorAll('.brawn-loader__letter');
    var delay = 0;

    letters.forEach(function (letter) {
      setTimeout(function () {
        letter.classList.add('is-visible');
      }, delay);
      delay += 60;
    });

    setTimeout(function () {
      overlay.classList.add('is-hiding');
      setTimeout(function () {
        overlay.remove();
        sessionStorage.setItem('brawn-loaded', '1');
      }, 340);
    }, delay + 280);
  }

  /* ─── 4. SCROLL REVEALS ─────────────────────────────────────── */
  function initScrollReveals() {
    var elements = document.querySelectorAll('.brawn-reveal');
    if (!elements.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = parseInt(entry.target.dataset.delay || '0', 10);
        setTimeout(function () {
          entry.target.classList.add('is-visible');
        }, delay);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ─── 5. WATERMARK PARALLAX ─────────────────────────────────── */
  function initParallax() {
    var wms = document.querySelectorAll(
      '.brawn-hero .brawn-wm-bg, .brawn-manifesto .brawn-wm-bg, .brawn-newsletter .brawn-wm-bg'
    );
    if (!wms.length) return;

    var ticking = false;

    function update() {
      wms.forEach(function (wm) {
        var section = wm.parentElement;
        var rect = section.getBoundingClientRect();
        var progress = -rect.top / Math.max(window.innerHeight, 1);
        var offset = progress * 80;
        wm.style.transform = wm.style.transform
          .replace(/translateY\([^)]*\)/, '')
          .replace('translateX(-50%)', 'translateX(-50%) translateY(' + offset + 'px)');
        if (!wm.style.transform.includes('translateY')) {
          wm.style.transform += ' translateY(' + offset + 'px)';
        }
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* ─── 7. HEADER ─────────────────────────────────────────────── */
  function initHeader() {
    var DESKTOP = 1024;

    var header   = document.getElementById('brawn-header');
    var menuBtn  = document.getElementById('brawn-menu-btn');
    var sentinel = document.getElementById('brawn-scroll-sentinel');
    var manifesto = document.querySelector('.brawn-manifesto');

    /* Fullscreen elements */
    var menu     = document.getElementById('brawn-menu');
    var closeBtn = document.getElementById('brawn-menu-close');
    var searchBtn    = document.getElementById('brawn-search-btn');
    var searchExpand = document.getElementById('brawn-search-expand');

    /* Dropdown elements */
    var dropdown      = document.getElementById('brawn-dropdown');
    var ddOverlay     = document.getElementById('brawn-dd-overlay');
    var ddSearchBtn   = document.getElementById('brawn-dd-search-btn');
    var ddSearchExp   = document.getElementById('brawn-dd-search-expand');

    /* Inline header search */
    var headerSearchBtn  = document.getElementById('brawn-header-search-btn');
    var headerSearchForm = document.getElementById('brawn-header-search-form');

    function openHeaderSearch() {
      if (!headerSearchForm) return;
      headerSearchForm.classList.add('is-open');
      if (headerSearchBtn) headerSearchBtn.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        var inp = headerSearchForm.querySelector('input');
        if (inp) inp.focus();
      }, 210);
    }

    function closeHeaderSearch() {
      if (!headerSearchForm) return;
      headerSearchForm.classList.remove('is-open');
      if (headerSearchBtn) headerSearchBtn.setAttribute('aria-expanded', 'false');
      var inp = headerSearchForm.querySelector('input');
      if (inp) inp.value = '';
    }

    if (!header) return;

    /* ── Scroll state via IntersectionObserver on sentinel ── */
    if (sentinel && typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
      }).observe(sentinel);
    }

    /* ── Dark section detection — reads manifesto position vs header ── */
    if (manifesto) {
      function checkDark() {
        var rect = manifesto.getBoundingClientRect();
        var headerH = header.offsetHeight;
        header.classList.toggle('is-dark', rect.top < headerH && rect.bottom > 0);
      }
      window.addEventListener('scroll', checkDark, { passive: true });
      checkDark();
    }

    /* ── FULLSCREEN menu (mobile < 1024px) ── */
    function openFullscreen() {
      if (!menu) return;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('brawn-menu-open');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
    }

    function closeFullscreen() {
      if (!menu || !menu.classList.contains('is-open')) return;
      menu.classList.add('is-closing');
      setTimeout(function () {
        menu.classList.remove('is-open', 'is-closing');
        menu.setAttribute('aria-hidden', 'true');
        if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('brawn-menu-open');
        if (menuBtn) menuBtn.focus();
        if (searchExpand) {
          searchExpand.classList.remove('is-open');
          searchExpand.setAttribute('aria-hidden', 'true');
        }
      }, 380);
    }

    if (closeBtn) closeBtn.addEventListener('click', closeFullscreen);

    /* Fullscreen search expand */
    if (searchBtn && searchExpand) {
      searchBtn.addEventListener('click', function () {
        var isOpen = searchExpand.classList.contains('is-open');
        if (isOpen) {
          searchExpand.classList.remove('is-open');
          searchExpand.setAttribute('aria-hidden', 'true');
        } else {
          searchExpand.classList.add('is-open');
          searchExpand.setAttribute('aria-hidden', 'false');
          var input = searchExpand.querySelector('input');
          if (input) setTimeout(function () { input.focus(); }, 330);
        }
      });
    }

    /* Inline header search button toggle */
    if (headerSearchBtn) {
      headerSearchBtn.addEventListener('click', function () {
        if (headerSearchForm && headerSearchForm.classList.contains('is-open')) {
          closeHeaderSearch();
        } else {
          openHeaderSearch();
        }
      });
    }

    if (headerSearchForm) {
      var headerInput = headerSearchForm.querySelector('input');
      if (headerInput) {
        headerInput.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' || e.key === 'Esc') closeHeaderSearch();
        });
      }
      document.addEventListener('click', function (e) {
        if (!headerSearchForm.classList.contains('is-open')) return;
        if (headerSearchBtn && headerSearchBtn.contains(e.target)) return;
        if (headerSearchForm.contains(e.target)) return;
        closeHeaderSearch();
      });
    }

    /* Close fullscreen when a nav link is clicked */
    if (menu) {
      menu.querySelectorAll('.brawn-menu__link').forEach(function (link) {
        if (link.tagName === 'A') {
          link.addEventListener('click', function () { closeFullscreen(); });
        }
      });
    }

    /* Mobile submenu toggles */
    if (menu) {
      menu.querySelectorAll('.brawn-menu__toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-submenu');
          var sub = document.getElementById(id);
          if (!sub) return;
          var open = sub.classList.contains('is-open');
          sub.classList.toggle('is-open', !open);
          sub.setAttribute('aria-hidden', open ? 'true' : 'false');
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    }

    /* ── DROPDOWN menu (desktop ≥ 1024px) ── */
    function openDropdown() {
      if (!dropdown) return;
      var panel = dropdown.querySelector('.brawn-dropdown__panel');
      if (panel && header) {
        panel.style.top = header.getBoundingClientRect().bottom + 'px';
      }
      dropdown.classList.add('is-open');
      dropdown.setAttribute('aria-hidden', 'false');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      if (!dropdown || !dropdown.classList.contains('is-open')) return;
      dropdown.classList.remove('is-open');
      dropdown.setAttribute('aria-hidden', 'true');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      if (ddSearchExp) {
        ddSearchExp.classList.remove('is-open');
        ddSearchExp.setAttribute('aria-hidden', 'true');
      }
    }

    /* Overlay click closes dropdown */
    if (ddOverlay) ddOverlay.addEventListener('click', closeDropdown);

    /* Click outside panel + trigger closes dropdown */
    document.addEventListener('click', function (e) {
      if (!dropdown || !dropdown.classList.contains('is-open')) return;
      var panel = dropdown.querySelector('.brawn-dropdown__panel');
      if (panel && panel.contains(e.target)) return;
      if (menuBtn && menuBtn.contains(e.target)) return;
      closeDropdown();
    });

    /* Dropdown search expand */
    if (ddSearchBtn && ddSearchExp) {
      ddSearchBtn.addEventListener('click', function () {
        var isOpen = ddSearchExp.classList.contains('is-open');
        if (isOpen) {
          ddSearchExp.classList.remove('is-open');
          ddSearchExp.setAttribute('aria-hidden', 'true');
        } else {
          ddSearchExp.classList.add('is-open');
          ddSearchExp.setAttribute('aria-hidden', 'false');
          var input = ddSearchExp.querySelector('input');
          if (input) setTimeout(function () { input.focus(); }, 310);
        }
      });
    }

    /* Close dropdown when a nav link is clicked */
    if (dropdown) {
      dropdown.querySelectorAll('.brawn-dropdown__link').forEach(function (link) {
        if (link.tagName === 'A') {
          link.addEventListener('click', function () { closeDropdown(); });
        }
      });
    }

    /* ── MENU button dispatcher ── */
    if (menuBtn) {
      menuBtn.addEventListener('click', function () {
        if (window.innerWidth >= DESKTOP) {
          /* Desktop: toggle dropdown */
          if (dropdown && dropdown.classList.contains('is-open')) {
            closeDropdown();
          } else {
            openDropdown();
          }
        } else {
          /* Mobile: open fullscreen */
          openFullscreen();
        }
      });
    }

    /* ── ESC key closes whichever is open ── */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (dropdown && dropdown.classList.contains('is-open')) closeDropdown();
      if (menu && menu.classList.contains('is-open')) closeFullscreen();
      closeHeaderSearch();
    });
  }

  /* ─── 6. CARD CART ──────────────────────────────────────────── */
  function initCardCart() {
    var toast = document.createElement('div');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    toast.style.cssText = [
      'position:fixed',
      'bottom:32px',
      'left:50%',
      'transform:translateX(-50%) translateY(16px)',
      'background:var(--hueso,#F4F0EA)',
      'border:1px solid var(--carbon,#1A1A1A)',
      'padding:16px 32px',
      'z-index:9999',
      'opacity:0',
      'transition:opacity 300ms ease,transform 300ms ease',
      'pointer-events:none',
      'min-width:220px',
      'text-align:center'
    ].join(';');
    document.body.appendChild(toast);

    var toastTimer;

    function showToast(title) {
      toast.innerHTML =
        '<span class="brawn-toast__label">AGREGADO AL CARRITO</span>' +
        '<span class="brawn-toast__product">' + (title || '') + '</span>';
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(16px)';
      }, 2400);
    }

    function updateCartCount(count) {
      document.querySelectorAll('#brawn-cart-badge, #brawn-cart-badge-mobile').forEach(function (badge) {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'inline-flex' : 'none';
      });
    }

    async function brawnOpenCartDrawer() {
      try {
        await customElements.whenDefined('cart-drawer');
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          return;
        }
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
        setTimeout(() => cartDrawer.classList.remove('animate'), 400);
      } catch(e) {
        const btn = document.querySelector('#cart-icon-bubble');
        if (btn) btn.click();
      }
    }

    document.addEventListener('click', function (e) {
      var sizeLink = e.target.closest('a.brawn-card__size[data-variant-id]');
      if (!sizeLink) return;
      e.preventDefault();

      var variantId = sizeLink.dataset.variantId;
      if (!variantId) return;

      var card = sizeLink.closest('.brawn-card');
      var nameEl = card && card.querySelector('.brawn-card__name');
      var title = nameEl ? nameEl.textContent.trim() : '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return Promise.all([
          fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }),
          fetch('/cart.js').then(function (r) { return r.json(); })
        ]);
      })
      .then(function (results) {
        var data = results[0];
        var cart = results[1];

        var cartDrawerEl = document.querySelector('cart-drawer');

        if (data['cart-drawer'] && cartDrawerEl) {
          var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var newInner = doc.querySelector('#CartDrawer .drawer__inner');
          var curInner = document.querySelector('#CartDrawer .drawer__inner');
          if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
          cartDrawerEl.classList.remove('is-empty');
        }

        updateCartCount(cart.item_count);
        showToast(title);
        var originalText = sizeLink.textContent;
        sizeLink.textContent = '✓';
        sizeLink.style.color = 'var(--cafe)';
        setTimeout(function () {
          sizeLink.textContent = originalText;
          sizeLink.style.color = '';
        }, 1000);
        setTimeout(function () { brawnOpenCartDrawer(); }, 150);
      })
      .catch(function () {
        showToast('No se pudo agregar');
      });
    });
  }

  /* ─── 7. HERO CROSSFADE ────────────────────────────────────── */
  function initHeroCrossfade() {
    var video = document.querySelector('.brawn-hero__bg-video');
    var img = document.querySelector('.brawn-hero__bg-image');
    if (!video || !img) return;

    if (window.matchMedia('(max-width: 1023px)').matches) return;

    video.style.transition = 'opacity 800ms ease';
    img.style.transition = 'opacity 800ms ease';
    img.style.position = 'absolute';
    img.style.inset = '0';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.display = 'block';
    img.style.opacity = '0';

    var showingVideo = true;

    setInterval(function () {
      if (showingVideo) {
        video.style.opacity = '0';
        img.style.opacity = '1';
        showingVideo = false;
      } else {
        img.style.opacity = '0';
        video.style.opacity = '1';
        if (video.paused) video.play();
        showingVideo = true;
      }
    }, 5000);
  }

  /* ─── 8. MARQUEE ────────────────────────────────────────────── */
  function initMarquees() {
    document.querySelectorAll('[data-marquee]').forEach(function (container) {
      var inner = container.querySelector('[data-marquee-inner]');
      if (!inner) return;

      var clone = inner.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      container.appendChild(clone);

      var speed = parseFloat(container.dataset.speed || '45');
      inner.style.animationDuration = speed + 's';
      clone.style.animationDuration = speed + 's';

      container.addEventListener('mouseenter', function () {
        inner.style.animationPlayState = 'paused';
        clone.style.animationPlayState = 'paused';
      });
      container.addEventListener('mouseleave', function () {
        inner.style.animationPlayState = 'running';
        clone.style.animationPlayState = 'running';
      });
    });
  }

})();
